// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Service } from "./service";

export class NormalService implements flatbuffers.IUnpackableObject<NormalServiceT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalService {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalService(bb: flatbuffers.ByteBuffer, obj?: NormalService): NormalService {
    return (obj || new NormalService()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalService(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalService,
  ): NormalService {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalService()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Service {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Service.Auto;
  }

  static startNormalService(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Service) {
    builder.addFieldInt16(0, message, Service.Auto);
  }

  static endNormalService(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalService(builder: flatbuffers.Builder, message: Service): flatbuffers.Offset {
    NormalService.startNormalService(builder);
    NormalService.addMessage(builder, message);
    return NormalService.endNormalService(builder);
  }

  unpack(): NormalServiceT {
    return new NormalServiceT(this.message());
  }

  unpackTo(_o: NormalServiceT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalServiceT {
    const t = new NormalServiceT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalServiceT implements flatbuffers.IGeneratedObject {
  constructor(public message: Service = Service.Auto) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalService.createNormalService(builder, this.message);
  }

  clone(): NormalServiceT {
    const obj = new NormalServiceT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalServiceT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalService(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
